import { useAuth } from './AuthContext';
import type { PermissionCode } from '../types';

/**
 * Hook kiểm tra quyền.
 *  - usePermission('FEATURE_CONFIRM') → boolean
 *  - Truyền mảng: true nếu có ÍT NHẤT một quyền trong danh sách.
 */
export function usePermission(code: PermissionCode | PermissionCode[]): boolean {
  const { permissions } = useAuth();
  const codes = Array.isArray(code) ? code : [code];
  return codes.some((c) => permissions.has(c));
}
